<template>
  <div>
    <div style="position: relative; width: 100vw; height: 100vh">
      <div id="map" style="width: 100%; height: 100%"></div>

      <div
        @click="confirmAddress"
        :disabled="!address"
        v-ripple
        class="addcartbtn Kanit myshadow"
      >
        <p>ยืนยันที่อยู่</p>
      </div>

      <div style="position: absolute; right: 10px; top: 10px; width: 92%">
        <v-row>
          <v-col cols="10">
            <v-text-field
              id="pac-input"
              v-model="input.search"
              dense
              outlined
              solo
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <span
        @click.stop="$emit('close')"
        style="position: absolute; right: 4px; top: 4px"
      >
        <v-icon style="font-size: 25px" color="red">mdi-close-thick</v-icon>
      </span>
    </div>
  </div>
</template>

<script>
var map;

export default {
  data() {
    return {
      input: {
        search: "",
      },
      geocoder: "",
      infowindow: "",
      alreadycalled: false,
      text: "",
      map: "",
      infoloading: false,
      haveGPS: false,
      autocomplete: null,
      storelocation: {
        lat: 13.8117067,
        lng: 100.4470965,
      },
      newwin: "",
      markerposition: {
        lat: null,
        lng: null,
      },
      currentCoords: {
        lat: 0,
        lng: 0,
      },
      address: null,
      marker: null,
      directionsService: "",
      directionsRenderer: "",
    };
  },
  mounted() {
    this.gmapInit();
  },
  methods: {
    confirmAddress() {
      var vm = this;

      var address2 =
        "\nhttps://www.google.com/maps?q=" +
        vm.markerposition.lat.toString() +
        "," +
        vm.markerposition.lng.toString();
      var address = this.address.address_components;
      var zip_code = address.find((el) => el.types.includes("postal_code"));
      var province = address.find((el) =>
        el.types.includes("administrative_area_level_1")
      );
      var district = address.find(
        (el) =>
          el.types.includes("administrative_area_level_2") ||
          el.types.includes("sublocality_level_1")
      );
      var sub_district = address.find(
        (el) =>
          el.types.includes("sublocality_level_2") ||
          el.types.includes("locality")
      );

      var data = {
        zipcode: zip_code ? zip_code.long_name : "",
        province: province ? province.long_name : "",
        amphoe: district ? district.long_name : "",
        tambon: sub_district ? sub_district.long_name : "",
        address: vm.address.formatted_address,
        address2: address2,
      };

      this.$emit("gmapaddress", data);
    },
    geocodeLatLng(lat, lng) {
      var vm = this;
      const latlng = { lat, lng };
      return new Promise((resolve) => {
        this.geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              vm.infowindow.setContent(results[0].formatted_address);
              vm.infowindow.open(map, vm.marker);
              vm.address = results[0];

              resolve();
            } else {
              window.alert("No results found");
            }
          } else {
            // window.alert("Geocoder failed due to: " + status);
            resolve();
          }
        });
      });
    },
    async gmapInit() {
      var vm = this;
      var latlng = new google.maps.LatLng({
        lat: 13.756331,
        lng: 100.501762,
      });
      map = new window.google.maps.Map(document.getElementById("map"), {
        center: latlng,
        zoom: 15,
        disableDefaultUI: true,
        clickableIcons: false,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        gestureHandling: "greedy",
        streetViewControl: false,
      });
      this.infowindow = new google.maps.InfoWindow();
      this.geocoder = new google.maps.Geocoder();
      map.addListener("center_changed", function () {
        vm.marker.setPosition(map.getCenter());
      });
      map.addListener("dragstart", function () {
        vm.infoloading = true;
        if (!vm.alreadycalled) {
          map.addListener("idle", async function (event) {
            vm.markerposition.lat = vm.marker.getPosition().lat();
            vm.markerposition.lng = vm.marker.getPosition().lng();
            await vm.geocodeLatLng(
              vm.markerposition.lat,
              vm.markerposition.lng
            );

            vm.infoloading = false;
          });
          vm.alreadycalled = true;
        }
      });
      var input = document.getElementById("pac-input");
      this.autocomplete = new google.maps.places.Autocomplete(input);
      this.autocomplete.bindTo("bounds", map);
      this.autocomplete.setFields([
        "address_components",
        "geometry",
        "icon",
        "name",
      ]);
      this.autocomplete.addListener("place_changed", async function () {
        var place = vm.autocomplete.getPlace();
        vm.marker.setPosition(place.geometry.location);
        vm.markerposition.lat = vm.marker.getPosition().lat();
        vm.markerposition.lng = vm.marker.getPosition().lng();
        map.panTo(vm.marker.getPosition());
        await vm.geocodeLatLng(vm.markerposition.lat, vm.markerposition.lng);
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name + "'");
          return;
        }
      });
      vm.marker = new google.maps.Marker({ map });
      vm.marker.setPosition(latlng);
      vm.markerposition.lat = vm.marker.getPosition().lat();
      vm.markerposition.lng = vm.marker.getPosition().lng();

      map.addListener("click", async function (e) {
        if (!vm.marker) {
          vm.marker = new google.maps.Marker({ map });
        }
        document.getElementById("map").focus();

        vm.marker.setPosition(e.latLng);
        map.panTo(vm.marker.getPosition());
        vm.markerposition.lat = vm.marker.getPosition().lat();
        vm.markerposition.lng = vm.marker.getPosition().lng();
        await vm.geocodeLatLng(vm.markerposition.lat, vm.markerposition.lng);
      });
    },
  },
};
</script>